import router from './router'

const loginRoutePath = '/login'
const defaultRoutePath = '/'

router.beforeEach((to, from, next) => {
  console.log(to, '路径=======》《')
  
  const requiresAuth = to.meta.requiresAuth
  
  if (requiresAuth) {
    const token = localStorage.getItem('token')
    
    if (token) {
      const userDataStr = localStorage.getItem('userData')
      
      if (userDataStr) {
        try {
          const userData = JSON.parse(userDataStr)
          const currentTime = new Date().getTime()
          
          if (userData.expireTime && currentTime > userData.expireTime) {
            localStorage.removeItem('userData')
            localStorage.removeItem('token')
            next({ path: loginRoutePath, query: { redirect: to.fullPath } })
            return
          }
        } catch (e) {
          console.error('解析 userData 失败', e)
          localStorage.removeItem('userData')
          localStorage.removeItem('token')
          next({ path: loginRoutePath, query: { redirect: to.fullPath } })
          return
        }
      }
      
      if (to.path === loginRoutePath) {
        next({ path: defaultRoutePath })
      } else {
        next()
      }
    } else {
      next({ path: loginRoutePath, query: { redirect: to.fullPath } })
    }
  } else {
    next()
  }
})
